module.exports = __webpack_public_path__ + "img/googleplay-badge.178ee808.png";